import { useContext } from "react";
import AppContext from "context/app";

export default function EditLink({ setEditOpen, ...props }) {
  const { user } = useContext(AppContext);

  if (!user?.CanAccessAdmin) {
    return null;
  }

  return (
    <li className="overflow-hidden bg-white px-4 py-4 shadow sm:rounded-md sm:px-6">
      <button
        type="button"
        className="inline-flex items-center rounded-md border border-transparent bg-red-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
        onClick={() => setEditOpen(true)}
        {...props}
      >
        Edit
      </button>
    </li>
  );
}